<template>
  <b-modal
    id="ingresar-pago-en-modulo-de-pagos-modal"
    size="xl"
    @shown="onShown"
    centered
    hide-footer
    lazy
    scrollable
    :no-close-on-backdrop="true"
  >
    <div class="card">
      <form
        @submit.prevent="submit"
        ref="form"
        v-promise-btn="{ action: 'submit' }"
      >
        <div class="container">
          <div class="row">
            <div class="col-12 text-center form-group form-group-sm">
              <h4 class="card-title">Ingresar pago</h4>
            </div>

            <div class="col-12 form-group form-group-sm bg-secondary">
              <label
                for="cliente"
                class="text-dark label"
                style="font-weight: 900"
                >Cliente
              </label>
              <input
                disabled
                type="text"
                class="form-control form-control-sm text-center bg-white"
                style="cursor: text"
                v-model="nombreCliente"
                id="cliente"
              />
            </div>
            <template v-if="deudaAnterior || totalAPagar">
              <div
                class="col-12 col-md-6 form-group form-group-sm bg-secondary"
              >
                <div class="container">
                  <label
                    for="deudaAnterior"
                    class="row text-dark label"
                    style="font-weight: 900"
                    >Deuda Anterior
                    <vue-numeric
                      id="deudaAnterior"
                      v-select-on-focus
                      currency="$"
                      thousand-separator="."
                      decimal-separator=","
                      :precision="2"
                      v-model="deudaAnterior"
                      :minus="true"
                      disabled
                      class="col-10 form-control form-control-sm text-center bg-white"
                    ></vue-numeric>
                    <button
                      @click="montoFacturaAnterior"
                      type="button"
                      class="col-2 form-control form-control-sm btn btn-success"
                    >
                      ⬇
                    </button>
                  </label>
                </div>
              </div>
              <div
                class="col-12 col-md-6 form-group form-group-sm bg-secondary"
              >
                <div class="container">
                  <label
                    for="deudaActual"
                    class="row text-dark label"
                    style="font-weight: 900"
                    >Deuda Actual
                    <vue-numeric
                      id="deudaActual"
                      v-select-on-focus
                      currency="$"
                      thousand-separator="."
                      decimal-separator=","
                      :precision="2"
                      v-model="totalAPagar"
                      :minus="true"
                      disabled
                      class="col-10 form-control form-control-sm text-center bg-white"
                    ></vue-numeric>
                    <button
                      @click="montoTotalFactura"
                      type="button"
                      class="col-2 form-control form-control-sm btn btn-success"
                      size="md"
                    >
                      ⬇
                    </button>
                  </label>
                </div>
              </div>
            </template>
          </div>

          <div class="row">
            <div class="col-12">
              <label class="label" for="">Ingresa pago</label>
              <card-item class="striped-tabled-with-hover">
                <div class="row">
                  <div class="col-12 col-md-4 form-group form-group-sm">
                    <div class="form-group form-group-sm">
                      <label for="monto" class="label">Método de pago</label>
                      <card-item class="striped-tabled-with-hover">
                        <template>
                          <div>
                            <label for="metodoPago">
                              <input
                                type="radio"
                                id="metodoPago"
                                :value="true"
                                v-model="metodoDePago"
                              />
                              Efectivo/Transferencia</label
                            >
                          </div>
                          <div>
                            <label for="metodoPago2">
                              <input
                                type="radio"
                                id="metodoPago2"
                                :value="false"
                                v-model="metodoDePago"
                              />
                              Cheque
                            </label>
                          </div>
                        </template>
                      </card-item>
                    </div>
                  </div>
                  <div class="col-12 col-md-4 form-group form-group-sm">
                    <label class="label" for="grupo">Lugar de cobranza</label>
                    <SelectorLugarCobranza v-model="lugarCobranza" />
                  </div>
                  <div class="col-12 col-md-4">
                    <div class="form-group form-group-sm">
                      <label for="fecha" class="label">Fecha</label>
                      <input
                        class="form-control bg-white text-center"
                        type="datetime-local"
                        id="fecha"
                        v-model="fecha"
                      />
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <div class="form-group form-group-sm">
                      <label for="monto" class="label">Monto</label>
                      <vue-numeric
                        id="monto"
                        v-select-on-focus
                        currency="$"
                        thousand-separator="."
                        decimal-separator=","
                        :precision="2"
                        v-model="montoAPagar"
                        :class="`form-control text-center bg-white${
                          !isMontoOk && isDirty ? ' is-invalid' : ''
                        }`"
                      ></vue-numeric>
                    </div>
                  </div>
                </div>
              </card-item>
            </div>
          </div>
          <div class="row" v-if="!metodoDePago">
            <div class="col-12">
              <label class="label" for="">Informacion de Cheque</label>
              <card-item class="striped-tabled-with-hover">
                <div class="row">
                  <div class="col-12 col-md-6 form-group form-group-s">
                    <label class="label" for="id_cliente">Banco</label>
                    <SelectorBanco v-model="banco" />
                  </div>
                  <div
                    class="col-12 col-md-3 form-group form-group-sm d-flex align-items-end pl-5"
                  >
                    <label class="label" for="cruzado">
                      <input
                        id="cruzado"
                        v-model="cruzado"
                        class="form-check-inline"
                        type="checkbox"
                      />
                      Cruzado
                    </label>
                  </div>
                  <div
                    class="col-12 col-md-3 form-group form-group-sm d-flex align-items-end pl-5"
                  >
                    <label for="chequeFisico" class="label">
                      <input
                        v-model="chequeFisico"
                        type="checkbox"
                        class="form-check-inline"
                        id="chequeFisico"
                      />
                      Cheque fisico</label
                    >
                  </div>

                  <div class="col-12 col-md-6 form-group form-group-sm">
                    <label for="fechaEmision" class="label"
                      >Fecha de emision</label
                    >
                    <input
                      :class="`form-control text-center bg-white${
                        !isFechaEmisionOk && isDirty ? ' is-invalid' : ''
                      }`"
                      type="date"
                      id="fechaEmision"
                      v-model="fechaEmisionCheque"
                    />
                  </div>
                  <div class="col-12 col-md-6 form-group form-group-sm">
                    <label for="fechaCobro" class="label">Fecha de cobro</label>
                    <input
                      :class="`form-control text-center bg-white${
                        !isFechaCobroOk && isDirty ? ' is-invalid' : ''
                      }`"
                      type="date"
                      id="fechaCobro"
                      v-model="fechaCobroCheque"
                    />
                  </div>
                </div>

                <div class="col-12" v-if="chequeFisico">
                  <label class="label" for="">Información adicional</label>
                  <card-item class="striped-tabled-with-hover">
                    <div class="row">
                      <div class="col-12 form-group form-group-sm">
                        <label for="numeroCheque" class="label"
                          >Nº Cheque</label
                        >
                        <input
                          type="text"
                          :class="`form-control form-control-sm text-center bg-white${
                            !isNroChequeOk && isDirty ? ' is-invalid' : ''
                          }`"
                          style="cursor: text"
                          v-model="nroCheque"
                          id="numeroCheque"
                        />
                      </div>
                      <div class="col-12 col-md-6 form-group form-group-sm">
                        <label for="emisor" class="label">Emisor</label>
                        <input
                          type="text"
                          :class="`form-control form-control-sm text-center bg-white${
                            !isEmisorOk && isDirty ? ' is-invalid' : ''
                          }`"
                          style="cursor: text"
                          v-model="emisor"
                          id="emisor"
                        />
                      </div>
                      <div class="col-12 col-md-6 form-group form-group-sm">
                        <label for="destinatario" class="label"
                          >Destinatario</label
                        >
                        <input
                          type="text"
                          :class="`form-control form-control-sm text-center bg-white${
                            !isDestinatarioOk && isDirty ? ' is-invalid' : ''
                          }`"
                          style="cursor: text"
                          v-model="destinatario"
                          id="destinatario"
                        />
                      </div>
                      <div class="col-12 form-group form-group-sm">
                        <label for="comentario" class="label">Comentario</label>
                        <textarea
                          type="textarea"
                          :class="`form-control form-control-sm text-center bg-white${
                            !isComentarioOk && isDirty ? ' is-invalid' : ''
                          }`"
                          style="cursor: text"
                          v-model="comentario"
                          id="comentario"
                        >
                        </textarea>
                      </div>
                    </div>
                  </card-item>
                </div>
              </card-item>
            </div>
          </div>
          <div class="row">
            <div
              class="col-12 col-md-6 ml-3 form-group form-group-sm d-flex align-items-center"
            >
              <label class="label" for="aplicarRetenciones">
                Aplica retenciones
              </label>
              <input
                id="aplicarRetenciones"
                v-model="aplicarRetenciones"
                class="ml-2 form-check-inline align-end"
                type="checkbox"
                style="zoom: 1.8"
              />
            </div>
          </div>
          <div class="row" v-if="aplicarRetenciones">
            <div class="col-12">
              <label class="label" for="">Aplica retenciones</label>
              <card-item class="striped-tabled-with-hover">
                <div class="row justify-content-around">
                  <div class="col-md-4">
                    <div class="form-group form-group-sm">
                      <label for="ingresos_brutos" class="label">IIBB</label>
                      <vue-numeric
                        style="
                          border: 2px solid #ff6a00;
                          background-color: rgba(255, 106, 0, 0.1);
                        "
                        id="ingresos_brutos"
                        v-select-on-focus
                        currency="$"
                        thousand-separator="."
                        decimal-separator=","
                        :precision="2"
                        v-model="ingresosBrutos"
                        class="form-control form-control-sm text-center"
                      ></vue-numeric>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group form-group-sm">
                      <label for="IVA" class="label">IVA</label>
                      <vue-numeric
                        style="
                          border: 2px solid #4b00ff;
                          background-color: rgba(75, 0, 255, 0.1);
                        "
                        id="IVA"
                        v-select-on-focus
                        currency="$"
                        thousand-separator="."
                        decimal-separator=","
                        :precision="2"
                        v-model="IVA"
                        class="form-control form-control-sm text-center"
                      ></vue-numeric>
                    </div>
                  </div>

                  <div class="col-md-4">
                    <div class="form-group form-group-sm">
                      <label for="ganancias" class="label"
                        >Ret. ganancias</label
                      >
                      <vue-numeric
                        style="
                          border: 2px solid #0072ff;
                          background-color: rgba(0, 114, 255, 0.1);
                        "
                        id="ganancias"
                        v-select-on-focus
                        currency="$"
                        thousand-separator="."
                        decimal-separator=","
                        :precision="2"
                        v-model="ganancias"
                        class="form-control form-control-sm text-center"
                      ></vue-numeric>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group form-group-sm">
                      <label for="im" class="label">IM</label>
                      <vue-numeric
                        style="
                          border: 2px solid #069d6e;
                          background-color: rgba(6, 157, 110, 0.1);
                        "
                        id="im"
                        v-select-on-focus
                        currency="$"
                        thousand-separator="."
                        decimal-separator=","
                        :precision="2"
                        v-model="IM"
                        class="form-control form-control-sm text-center"
                      ></vue-numeric>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group form-group-sm">
                      <label for="suss" class="label">SUSS</label>
                      <vue-numeric
                        style="
                          border: 2px solid #ffb800;
                          background-color: rgba(255, 184, 0, 0.1);
                        "
                        id="suss"
                        v-select-on-focus
                        currency="$"
                        thousand-separator="."
                        decimal-separator=","
                        :precision="2"
                        v-model="SUSS"
                        class="form-control form-control-sm text-center"
                      ></vue-numeric>
                    </div>
                  </div>
                </div>
              </card-item>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="d-flex justify-content-between">
                <button
                  @click="cerrarModal"
                  type="button"
                  class="btn btn-danger"
                >
                  Cancelar
                </button>
                <button type="submit" class="btn btn-primary">Confirmar</button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </b-modal>
</template>
<script>
import SelectorLugarCobranza from "../Clientes/shared/SelectorLugarCobranza.vue";
import axios from "axios";
import moment from "moment";
import NombreCliente from "../Clientes/shared/NombreCliente";
import { formatM, formatMDecimalConPunto } from "@/lib/utils/accountingJsFns";
import { get, isNil } from "lodash-es";
import vueNumeric from "../../lib/utils/vue-numeric.vue";
import SelectorBanco from "../Clientes/shared/SelectorBanco.vue";

export default {
  name: "ingresar-pago-en-modulo-de-pagos-modal",
  props: ["situacionCliente"],
  mixins: [NombreCliente],
  components: { SelectorLugarCobranza, vueNumeric, SelectorBanco },
  mounted() {
    this.getNombreCliente(this.situacionCliente.id_cliente);
  },
  data: () => ({
    isDirty: false,
    aplicarRetenciones: false,
    nroCheque: "",
    emisor: "",
    destinatario: "",
    comentario: "",
    fechaEmisionCheque: null,
    chequeFisico: false,
    IM: 0,
    SUSS: 0,
    deudaAnterior: 0,
    totalAPagar: 0,
    montoAPagar: 0,
    lugarCobranza: null,
    ingresosBrutos: 0,
    IVA: 0,
    ganancias: 0,
    fecha: null,
    metodoDePago: true,
    cruzado: false,
    fechaCobroCheque: null,
    banco: null,
    valorRedondeo: null,
  }),
  computed: {
    isMontoOk() {
      return (
        !!this.montoAPagar ||
        this.ingresosBrutos !== 0 ||
        this.IVA !== 0 ||
        this.ganancias !== 0 ||
        this.IM !== 0 ||
        this.SUSS !== 0
      );
    },
    isLugarPagoOk() {
      return !isNil(this.lugarCobranza);
    },
    Fecha() {
      const fechaIngreso = moment().format("YYYY-MM-DD HH:mm");
      return fechaIngreso;
    },
    isDatosDeChequeOk() {
      return this.isFechaEmisionOk && this.isFechaCobroOk;
    },
    isPagoConChequeFisicoOk() {
      return (
        this.isNroChequeOk &&
        this.isEmisorOk &&
        this.isDestinatarioOk &&
        this.isComentarioOk
      );
    },
    isNroChequeOk() {
      return this.nroCheque !== "";
    },
    isEmisorOk() {
      return this.emisor !== "";
    },
    isDestinatarioOk() {
      return this.destinatario !== "";
    },
    isComentarioOk() {
      return this.comentario !== "";
    },
    isFechaEmisionOk() {
      return !isNil(this.fechaEmisionCheque);
    },
    isFechaCobroOk() {
      return !isNil(this.fechaCobroCheque);
    },
  },
  methods: {
    async exito() {
      this.$msgBoxOk("Pago realizado con exito!");
    },
    montoTotalFactura() {
      this.montoAPagar = this.totalAPagar;
    },
    montoFacturaAnterior() {
      this.montoAPagar = this.deudaAnterior;
    },
    async GetValorRedondeo() {
      const resp = await axios.post("/execute", {
        method: "UTL.GetRedondeo",
        parameters: [],
      });
      if (resp.data.ok) {
        this.valorRedondeo = parseFloat(
          get(resp.data, "result[0][0].redondeo_cliente", null),
        );
      }
      return resp.data;
    },
    async confirmarImporteAPagar() {
      await this.GetValorRedondeo();

      const h = this.$createElement;

      let confirmarImporte = false;
      const suma =
        this.montoAPagar +
        this.ingresosBrutos +
        this.IVA +
        this.ganancias +
        this.IM +
        this.SUSS;

      let resultado;
      let respuesta;

      if (this.totalAPagar > suma) {
        resultado = this.totalAPagar - suma;
        if (this.valorRedondeo && resultado <= this.valorRedondeo) {
          respuesta = `La deuda sería ${formatM(resultado)}; por el importe restante, se aplicará redondeo a favor del cliente.`;
        } else {
          respuesta = `Faltarían ${formatM(resultado)} para cancelar la deuda `;
        }
      } else if (this.totalAPagar < suma) {
        resultado = suma - this.totalAPagar;
        respuesta = ` Está pagando ${formatM(resultado)} más de su deuda `;
      } else if (this.totalAPagar == suma) {
        respuesta = `La cuenta queda cero `;
      }
      const titulo = h("div", { class: ["custom-message"] }, [
        h(
          "p",
          { class: ["font-weight-bold text-uppercase"] },
          `Revisar valores`,
        ),
      ]);

      const mensaje = h("table", { class: ["w-100"] }, [
        h("tr", [
          h("td", [h("strong", `Detalle`)]),
          h("td", { style: "text-align:end" }, [h("strong", `$`)]),
        ]),
        h("tr", [
          h("td", `Monto`),
          h("td", { style: "text-align:end" }, formatM(this.montoAPagar)),
        ]),
        h(
          "tr",
          this.ingresosBrutos != 0
            ? [
                h("td", `Ingresos brutos`),
                h(
                  "td",
                  { style: "text-align:end" },
                  formatM(this.ingresosBrutos),
                ),
              ]
            : ``,
        ),
        h(
          "tr",
          this.IVA != 0
            ? [
                h("td", `IVA`),
                h("td", { style: "text-align:end" }, formatM(this.IVA)),
              ]
            : ``,
        ),
        h(
          "tr",
          this.IM != 0
            ? [
                h("td", `Impuestos municipales`),
                h("td", { style: "text-align:end" }, formatM(this.IM)),
              ]
            : ``,
        ),
        h(
          "tr",
          this.ganancias != 0
            ? [
                h("td", `Ganancias`),
                h("td", { style: "text-align:end" }, formatM(this.ganancias)),
              ]
            : ``,
        ),
        h(
          "tr",
          this.SUSS != 0
            ? [
                h("td", `Sistema Único de Seguridad Social`),
                h("td", { style: "text-align:end" }, formatM(this.SUSS)),
              ]
            : ``,
        ),
        h("br", ``),
        h("tr", [
          h("td", [h("strong", `Total a abonar`)]),
          h("td", [h("strong", { style: "text-align:end" }, formatM(suma))]),
        ]),
        h("tr", [
          h("td", [
            h("strong", { style: "font-style:italic" }, `${respuesta}`),
          ]),
        ]),
      ]);

      confirmarImporte = this.$bvModal.msgBoxConfirm([mensaje], {
        title: [titulo],
        headerClass: "",
        centered: true,
        okTitle: "Aceptar",
        cancelTitle: "Cancelar",
      });
      return confirmarImporte;
    },
    async submit() {
      this.isDirty = true;
      if (!this.isMontoOk) {
        await this.$msgBoxOk("Por favor, ingrese un monto o retención.");
        return;
      }

      if (!this.isLugarPagoOk) {
        await this.$msgBoxOk("Por favor, seleccione una boca de cobranza.");
        return;
      }

      if (!this.metodoDePago) {
        if (!this.isDatosDeChequeOk) {
          await this.$msgBoxOk("Por favor, complete fechas de cheque.");
          return;
        }

        if (this.chequeFisico) {
          if (!this.isPagoConChequeFisicoOk) {
            await this.$msgBoxOk(
              "Por favor, complete los campos adicionales de cheque fisico.",
            );
            return;
          }
        }
      }

      try {
        //verificar lugar de cobranza seleccionado
        let ubicacionCobranzaSeleccionado =
          this.lugarCobranza.id_ubicacion_dinero;
        let ubicacionCobranzaPredeterminado =
          this.situacionCliente.id_ubicacion_dinero;
        let ubicacionAMandar = this.lugarCobranza.id_ubicacion_dinero;
        let cambiarUbicacionPago = false;

        if (ubicacionCobranzaSeleccionado !== ubicacionCobranzaPredeterminado) {
          const confirmacion = await this.$bvModal.msgBoxConfirm(
            "Este cliente suele abonar en otra boca de cobranza.¿Está seguro que desea abonar en la boca de cobranza seleccionada?",
            {
              title: "Advertencia",
              centered: true,
              okTitle: "SI",
              cancelTitle: "NO",
            },
          );
          if (!confirmacion) {
            return;
          } else {
            //cambiar lugar de cobranza predeterminado al seleccionado para pagos futuros
            cambiarUbicacionPago = await this.$bvModal.msgBoxConfirm(
              "¿Quiere guardar esta ubicación como predeterminada para futuros pagos?",
              {
                title: "Confirmación",
                centered: true,
                okTitle: "SI",
                cancelTitle: "NO",
              },
            );
          }
        }

        //si lugarCobranza cambia
        if (cambiarUbicacionPago) {
          const resp = await axios.post("/execute", {
            method: "CLI.ModificarBocaCobranzaByClienteId",
            parameters: [
              { name: "id_cliente", value: this.situacionCliente.id_cliente },
              {
                name: "id_cobranza_lugarPago",
                value: this.lugarCobranza.id_cobranza_lugarPago,
              },
            ],
          });
          if (resp.data.ok) {
            ubicacionAMandar = this.lugarCobranza.id_ubicacion_dinero;
            this.$bvToast.toast(
              "La boca de cobranza ha sido modificada con éxito.",
              { variant: "success" },
            );
          } else {
            this.$msgBoxOk(
              "Ups!.Algo ha salido mal.No se pudo cambiar la boca de pago como predeterminada.",
            );
          }
        }
        //confirmar importe a abonar
        let confirmarImporte = await this.confirmarImporteAPagar();
        if (!confirmarImporte) {
          return;
        } else {
          const respuesta = await axios.post("/execute", {
            method: "CLI.IngresarPagoByCobranzas",
            parameters: [
              { name: "id_cliente", value: this.situacionCliente.id_cliente },
              { name: "monto_total", value: this.montoAPagar },
              {
                name: "fecha_ingreso_pago",
                value: moment(this.fecha).format("YYYY-MM-DD HH:mm"),
              },
              {
                name: "id_ubicacion_dinero",
                value: ubicacionAMandar,
              },
              { name: "deuda_real", value: this.totalAPagar },
              { name: "iibb", value: this.ingresosBrutos },
              { name: "iva", value: this.IVA },
              { name: "ganancias", value: this.ganancias },
              { name: "im", value: this.IM },
              { name: "suss", value: this.SUSS },
              { name: "metodo_de_pago", value: this.metodoDePago ? 0 : 1 },
              { name: "banco", value: this.banco ? this.banco.nombre : null },
              { name: "cruzado", value: this.cruzado ? 1 : 0 },
              { name: "fecha_cobro", value: this.fechaCobroCheque },
              { name: "fecha_emision", value: this.fechaEmisionCheque },
              { name: "nro_cheque", value: this.nroCheque },
              { name: "emisor", value: this.emisor },
              { name: "destinatario", value: this.destinatario },
              { name: "comentario_del_cheque", value: this.comentario },
              { name: "cheque_fisico", value: this.chequeFisico ? 1 : 0 },
            ],
          });

          if (respuesta.data.ok) {
            await this.$msgBoxOk("Pago realizado con exito!");
            this.$emit("update");
            this.cerrarModal();
          } else {
            await this.$msgBoxOk(
              get(
                respuesta,
                "data.message",
                "Algo salio mal. Se recibio ok:false pero sin mensaje",
              ),
            );
          }
          return respuesta.data;
        }
      } catch (e) {
        this.$msgBoxOk(e.toString());
      }
    },
    cerrarModal() {
      this.$bvModal.hide("ingresar-pago-en-modulo-de-pagos-modal");
    },
    onShown() {
      this.totalAPagar = this.situacionCliente.Total_a_pagar
        ? formatMDecimalConPunto(this.situacionCliente.Total_a_pagar)
        : 0;
      this.deudaAnterior = this.situacionCliente.deuda_anterior
        ? formatMDecimalConPunto(this.situacionCliente.deuda_anterior)
        : 0;
      this.montoAPagar = 0;
      this.lugarCobranza = this.situacionCliente.id_cobranza_lugarPago;
      this.ingresosBrutos = 0;
      this.IVA = 0;
      this.ganancias = 0;
      this.IM = 0;
      this.SUSS = 0;
      this.fecha = this.Fecha;
      this.banco = "";
      this.fechaCobroCheque = null;
      this.cruzado = false;
      this.metodoDePago = true;
      this.nroCheque = "";
      this.emisor = "";
      this.destinatario = "";
      this.comentario = "";
      this.fechaEmisionCheque = null;
      this.chequeFisico = false;
      this.isDirty = false;
    },
  },
  watch: {
    metodoDePago() {
      this.fechaCobroCheque = null;
      this.fechaEmisionCheque = null;
      this.chequeFisico = false;
      this.cruzado = false;
      this.isDirty = false;
    },
    chequeFisico() {
      this.comentario = "";
      this.nroCheque = "";
      this.emisor = "";
      this.destinatario = "";
      this.isDirty = false;
    },
  },
};
</script>
